// extracted by mini-css-extract-plugin
export default {"form":"IpForm_form__f2i+Z","input":"IpForm_input__UNaeQ","button":"IpForm_button__aDl0T"};